import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";
import { SCRIPT_TYPES } from "../../../constants/app-constants";

export const INITIAL_STATE = {
    [SCRIPT_TYPES.mmi]: false
};

export const scriptLoaded = (state = INITIAL_STATE, { data }) => {
    return { ...state, ...data };
};

export const HANDLERS = {
    [Types.SCRIPT_LOADED]: scriptLoaded

};

export default createReducer(INITIAL_STATE, HANDLERS);
